type SessionExpiryFetchOptions = {
  apiBaseUrl: string;
  appOrigin: string;
  fetch: typeof globalThis.fetch;
  getSessionGeneration: () => string | null;
  notify: () => void;
};

function getRequestUrl(input: RequestInfo | URL, appOrigin: string): URL {
  if (input instanceof Request) return new URL(input.url);
  return new URL(input.toString(), appOrigin);
}

function isAppApiRequest(input: RequestInfo | URL, apiBaseUrl: string, appOrigin: string): boolean {
  const requestUrl = getRequestUrl(input, appOrigin);
  const apiUrl = new URL(apiBaseUrl, appOrigin);
  const apiPath = apiUrl.pathname.replace(/\/$/, '');

  return (
    requestUrl.origin === apiUrl.origin &&
    (requestUrl.pathname === apiPath || requestUrl.pathname.startsWith(`${apiPath}/`))
  );
}

export function createSessionExpiryFetch({
  apiBaseUrl,
  appOrigin,
  fetch,
  getSessionGeneration,
  notify,
}: SessionExpiryFetchOptions): typeof globalThis.fetch {
  return async (input, init) => {
    let requestSessionGeneration: string | null = null;

    try {
      requestSessionGeneration = getSessionGeneration();
    } catch {
      return fetch(input, init);
    }

    const response = await fetch(input, init);
    let currentSessionGeneration: string | null = null;

    try {
      currentSessionGeneration = getSessionGeneration();
    } catch {
      return response;
    }

    if (
      response.status === 401 &&
      requestSessionGeneration !== null &&
      requestSessionGeneration === currentSessionGeneration &&
      isAppApiRequest(input, apiBaseUrl, appOrigin)
    ) {
      notify();
    }

    return response;
  };
}

export function installSessionExpiryFetch(options: Omit<SessionExpiryFetchOptions, 'fetch'>): void {
  const originalFetch = window.fetch.bind(window);
  window.fetch = createSessionExpiryFetch({ ...options, fetch: originalFetch });
}
